import styled from 'styled-components';

interface ContainerProps {
  color: string;
  type: string;
}

export const Container = styled.div<ContainerProps>`
  .card {
    display: flex;
    flex-direction: row;
    border: 1px solid ${(props) => props.color || '#4b8a7d'};
    border-radius: 8px;
    overflow: hidden;
    max-width: 400px;
    font-family: Arial, sans-serif;
  }

  .time {
    background-color: ${(props) => props.color || '#4b8a7d'};
    color: ${(props) => (props.type === 'progress' ? 'black' : 'white')};
    font-size: 16px;
    font-weight: bold;
    padding: 10px 15px;
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 80px;
  }

  .content {
    padding: 10px;
    flex-grow: 1;
  }

  .content .company {
    font-size: 12px;
    color: #777;
  }

  .content .date {
    font-weight: bold;
    font-size: 14px;
    color: #333;
  }

  .content .description {
    margin-top: 5px;
    font-size: 14px;
    color: #555;
  }

  .description {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: initial;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
  }
`;
